import {ListItem} from "@domain/common/list-view/list-item";
import {TypePortee} from '@domain/workflow/workflow';

/**
 * Modèle de la balise
 */
export class Balise implements ListItem {
    idBalise: number;
    idPortee: TypePortee | '';
    nom: string;
    description: string;
    requeteSQL: string;
    isSelected?: boolean;

    getKey(): number {
        return this.idBalise;
    }
}

/**
 * Type de portée des balises
 */
export enum TypePorteeBalise {
    NF = 'NF',
    OD = 'OD',
    FC = 'FC',
    AV = 'AV',
    OT = 'OT',
    DV = 'DV',
    IN = 'IN'
}
